import React, { useState, useEffect, useMemo, useCallback, useRef } from 'react'; 
import { db, paths } from '../../firebase/config';
import {
  doc,
  getDoc,
  addDoc,
  setDoc,
  updateDoc,
  deleteDoc,
  onSnapshot,
  collection,
  query,
  where,
  getDocs,
  runTransaction,
  serverTimestamp,
  Timestamp,
  orderBy,
  limit
} from "firebase/firestore";
import { useAuth, logAuditoria } from '../../context/AuthContext';
import { Modal } from '../../components/Modal';
import { Button } from '../../components/Button';
import { OpcaoCard } from '../../components/OpcaoCard';
import { LoadingSpinner } from '../../components/LoadingSpinner';
import { ChangePasswordModal } from '../../components/ChangePasswordModal';
import { EstagioOpcionalModal } from '../../components/EstagioOpcionalModal'; 
import { RelatorioEstagioModal } from '../../components/RelatorioEstagioModal'; 
import { QueimogramaModal } from '../../components/QueimogramaModal';
import CadeteMap from '../../components/CadeteMap';
import { PesquisaCadetes } from '../cadete/PesquisaCadetes';
import {
  getCPAName,
  formatarData,
  getNormalizedDateString
} from '../../utils/helpers';

// --- ESTILOS RESPONSIVOS E ANIMAÇÕES (ATUALIZADOS) ---
const styleTag = `
  /* --- ESTILOS GERAIS --- */
  .main-container { background-color: #f4f6f8; min-height: 100vh; }
  .filter-toggle-btn { background: white; border: 1px solid #e2e8f0; padding: 8px; border-radius: 8px; cursor: pointer; display: flex; align-items: center; justify-content: center; color: #4a5568; box-shadow: 0 2px 4px rgba(0,0,0,0.05); transition: all 0.2s; }
  .filter-toggle-btn:hover { background: #f8fafc; }
  .gear-animated { transition: transform 0.4s ease-in-out; }
  .gear-animated.open { transform: rotate(-180deg); }
  .gear-animated.closed { transform: rotate(0deg); }
  .btn-add-animated { background-color: #38a169; color: white; border: none;  border-radius: 8px; padding: 10px 16px; cursor: pointer; display: flex; align-items: center; gap: 8px; box-shadow: 0 4px 6px rgba(56, 161, 105, 0.4); transition: all 0.3s ease; height: 42px; }
  .btn-add-animated span { max-width: 0; opacity: 0; white-space: nowrap; transition: all 0.3s ease; font-weight: 700; font-size: 13px; }
  .btn-add-animated:hover { padding: 10px 20px; gap: 8px; }
  .btn-add-animated:hover span { max-width: 150px; opacity: 1; }
  .desktop-controls-wrapper { display: none; }
  .mobile-btn-wrapper { display: block; }
  .mobile-filters-panel { display: block; }
  .filters-panel { background-color: #f5f7fa; padding: 16px; border-radius: 12px; box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1); margin-bottom: 16px; border: 1px solid #e2e8f0; animation: fadeInDown 0.3s ease-out; transform-origin: top center; }
  @keyframes fadeInDown { from { opacity: 0; transform: translateY(-10px) scaleY(0.95); } to { opacity: 1; transform: translateY(0) scaleY(1); } }
  .leadership-container { display: flex; align-items: flex-end; gap: 12px; }
  .leadership-item { flex: 1; min-width: 0; }
  .modal-overlay { position: fixed; inset: 0; background-color: rgba(15, 23, 42, 0.5); backdrop-filter: blur(4px); display: flex; justify-content: center; align-items: center; z-index: 1000; padding: 16px; animation: fadeIn 0.2s ease-out; }
  .modal-content { background-color: #f5f7fa; padding: 20px; border-radius: 12px; width: 100%; max-width: 520px; max-height: 95vh; overflow-y: auto; box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1); animation: slideUp 0.3s ease-out; }
  .modal-title { margin-top: 0; font-size: 18px; color: #1e293b; margin-bottom: 16px; font-weight: 800; }
  .form-group { margin-bottom: 12px; }
  .form-row { display: flex; gap: 12px; margin-bottom: 12px; flex-wrap: wrap; }
  .form-row > div { flex: 1 1 45%; }
  .form-section { padding: 12px; border-radius: 10px; margin-bottom: 16px; border: 1px solid #e2e8f0; background-color: #ffffff; }
  .form-section-light { padding: 10px 12px; border: 1px solid #e2e8f0; border-radius: 10px; background-color: #f8fafc; margin-bottom: 12px; }
  .modal-actions { display: flex; justify-content: flex-end; gap: 10px; margin-top: 16px; }
  .modern-label { display: block; font-size: 10px; font-weight: 700; color: #64748b; margin-bottom: 4px; text-transform: uppercase; letter-spacing: 0.5px; }
  .modern-input { width: 100%; padding: 8px 12px; border-radius: 8px; border: 1.5px solid #e2e8f0; font-size: 12px; color: #1e293b; background-color: #f8fafc; transition: all 0.2s ease; box-sizing: border-box; outline: none; font-family: inherit; height: 36px; }
  .modern-input:focus { border-color: #3b82f6; background-color: #ffffff; box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.15); }
  select.modern-input { appearance: none; background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' fill='none' viewBox='0 0 24 24' stroke='%2364748b'%3E%3Cpath stroke-linecap='round' stroke-linejoin='round' stroke-width='2' d='M19 9l-7 7-7-7'%3E%3C/path%3E%3C/svg%3E"); background-repeat: no-repeat; background-position: right 12px center; background-size: 14px; padding-right: 32px; cursor: pointer; }
  .multi-select-container { border: 1.5px solid #e2e8f0; border-radius: 8px; background: #f8fafc; max-height: 200px; overflow-y: auto; }
  .checkbox-item { display: flex; align-items: center; padding: 8px 12px; cursor: pointer; border-bottom: 1px solid #f1f5f9; transition: background 0.2s; }
  .checkbox-item:last-child { border-bottom: none; }
  .checkbox-item:hover { background-color: #edf2f7; }
  .checkbox-item.selected { background-color: #eff6ff; }
  .custom-checkbox { width: 16px; height: 16px; border: 2px solid #cbd5e1; border-radius: 4px; margin-right: 10px; display: flex; align-items: center; justify-content: center; transition: all 0.2s; flex-shrink: 0; }
  .checkbox-item.selected .custom-checkbox { background-color: #3b82f6; border-color: #3b82f6; }
  .checkbox-tick { color: white; font-size: 10px; font-weight: bold; }
  .cadete-name-select { font-size: 12px; color: #334155; font-weight: 600; }
  .toggle-mode-btn { background: none; border: none; font-size: 10px; color: #3b82f6; font-weight: 700; cursor: pointer; text-decoration: underline; padding: 0; }
  .modern-btn-primary { padding: 8px 20px; border-radius: 8px; border: none; background: #3b82f6; color: white; font-weight: 600; font-size: 13px; cursor: pointer; height: 36px; }
  .modern-btn-secondary { padding: 8px 20px; border-radius: 8px; border: none; background: #f1f5f9; color: #475569; font-weight: 600; font-size: 13px; cursor: pointer; height: 36px; }
  .modern-chip-btn { font-size: 11px; padding: 6px 12px; cursor: pointer; background-color: #f0fdf4; border: 1px solid #bbf7d0; border-radius: 20px; color: #166534; font-weight: 600; }

  @keyframes fadeIn { from { opacity: 0; } to { opacity: 1; } }
  @keyframes slideUp { from { opacity: 0; transform: translateY(15px); } to { opacity: 1; transform: translateY(0); } }

  .bottom-nav-bar { display: none; }
  .conference-list { background: white; border-radius: 8px; border: 1px solid #e2e8f0; overflow: hidden; box-shadow: 0 2px 4px rgba(0,0,0,0.05); display: grid; grid-template-columns: 1fr 1fr; margin-bottom: 24px; width: 100%; }
  .conference-item { padding: 10px 8px; border-bottom: 1px solid #f1f5f9; border-right: 1px solid #f1f5f9; display: flex; align-items: center; justify-content: flex-start; background: #fff; }
  .conference-item:nth-child(even) { border-right: none; }
  .conference-list > :nth-last-child(-n+2):nth-child(odd), .conference-list > :nth-last-child(1):nth-child(even) { border-bottom: none; }
  .conference-avatar { width: 24px; height: 24px; border-radius: 50%; background: #eff6ff; color: #3b82f6; display: flex; align-items: center; justify-content: center; font-weight: 800; font-size: 11px; border: 1px solid #bfdbfe; flex-shrink: 0; }
  .conference-name { font-size: 11px; font-weight: 700; color: #334155; white-space: nowrap; overflow: hidden; text-overflow: ellipsis; margin-left: 8px; text-transform: uppercase; flex: 1; }

  .kpi-modern-wrapper { background-color: white; border-radius: 12px; overflow: hidden; border: 1px solid #e2e8f0; margin-bottom: 16px; box-shadow: 0 4px 6px -1px rgba(0,0,0,0.05); display: flex; flex-direction: column; }
  .kpi-modern-main { background: linear-gradient(135deg, #1e3a8a, #172554); padding: 16px 20px; display: flex; align-items: center; justify-content: space-between; color: white; position: relative; }
  .kpi-modern-main-title { font-size: 11px; font-weight: 700; text-transform: uppercase; letter-spacing: 0.5px; opacity: 0.9; margin-bottom: 4px; }
  .kpi-modern-main-value { font-size: 36px; font-weight: 800; line-height: 1; }
  .kpi-modern-main-icon { opacity: 0.2; transform: scale(1.2); margin-right: 10px; }
  .kpi-modern-subs { display: flex; flex-direction: row; background-color: #e2e8f0; gap: 1px; }
  .kpi-modern-sub-card { background-color: white; padding: 12px 16px; display: flex; align-items: center; gap: 12px; flex: 1; }
  .kpi-modern-sub-icon { width: 36px; height: 36px; border-radius: 50%; display: flex; align-items: center; justify-content: center; flex-shrink: 0; }
  .kpi-modern-sub-title { font-size: 10px; color: #64748b; font-weight: 700; text-transform: uppercase; margin-bottom: 2px; }
  .kpi-modern-sub-value { font-size: 20px; font-weight: 800; color: #1e293b; line-height: 1; }

  @media (max-width: 768px) {
    .main-container { padding: 12px 2px 75px 2px !important; overflow-x: hidden; }
    .hidden-mobile { display: none !important; }
    .mobile-stack { flex-direction: row !important; align-items: flex-start !important; justify-content: space-between !important; }
    
    .responsive-table { width: 100% !important; display: block !important; margin-bottom: 20px; border-collapse: separate; border-spacing: 0; }
    .responsive-table thead { display: none; }
    
    .responsive-card { display: block; width: 100%; border: 1px solid #e2e8f0; border-radius: 8px; margin-bottom: 12px; background: #fff; overflow: hidden; box-sizing: border-box; box-shadow: 0 1px 3px rgba(0,0,0,0.02); }
    .responsive-card tr { display: block; width: 100%; }
    
    .mobile-header-row td { padding: 0 !important; border-bottom: none !important; display: block; width: 100%; box-sizing: border-box; }
    .cadete-header { display: flex; justify-content: space-between; align-items: center; padding: 12px 14px; cursor: pointer; background: #fff; width: 100%; box-sizing: border-box; gap: 8px; border-bottom: 1px solid transparent; transition: background 0.2s, border 0.2s; }
    .expanded .cadete-header { border-bottom: 1px solid #e2e8f0; background: #f8fafc; }
    
    .cadete-header-info { display: flex; align-items: center; gap: 8px; flex: 1; min-width: 0; }
    .cadete-name-mobile { flex: 0 0 145px; font-weight: 800; color: #1e293b; font-size: 13px; text-transform: uppercase; white-space: nowrap; overflow: hidden; text-overflow: ellipsis; }
    .cadete-tag-mobile { padding: 4px 8px; border-radius: 6px; font-size: 9px; font-weight: 800; white-space: nowrap; }
    .arrow-icon { transition: transform 0.3s ease; color: #3b82f6; flex-shrink: 0; display: flex; align-items: center; }
    .expanded .arrow-icon { transform: rotate(180deg); }

    .data-row { display: none !important; }
    .expanded .data-row { display: block !important; padding: 4px 0; }
    
    .desktop-only-cell { display: none !important; }

    .responsive-card td { display: flex; flex-direction: column; align-items: flex-start; padding: 8px 14px !important; border-bottom: 1px solid #f1f5f9 !important; font-size: 12px; width: 100%; box-sizing: border-box; }
    .responsive-card td:last-child { border-bottom: none !important; }
    .data-row td::before { content: attr(data-label); font-weight: 800; color: #64748b; text-transform: uppercase; font-size: 10px; margin-bottom: 4px; display: block; }
    
    .mobile-actions-wrapper { display: flex; gap: 8px; width: 100%; margin-top: 6px; }
    .mobile-actions-wrapper button { flex: 1; justify-content: center; height: 36px; }
    .mobile-actions-wrapper span { display: inline; font-size: 12px; }
    
    .btn-add-animated { padding: 8px 16px !important; border-radius: 8px !important; height: 36px !important; gap: 6px !important; width: auto !important; }
    .btn-add-animated span { max-width: 200px !important; opacity: 1 !important; }
    .bottom-nav-bar { display: flex !important; position: fixed; bottom: 0; left: 0; right: 0; background-color: #ffffff; box-shadow: 0 -2px 10px rgba(0, 0, 0, 0.05); justify-content: space-around; align-items: center; height: 60px; z-index: 900; border-top: 1px solid #e2e8f0; }
    .nav-item { display: flex; flex-direction: column; align-items: center; justify-content: center; flex: 1; height: 100%; color: #94a3b8; text-decoration: none; cursor: pointer; transition: color 0.2s; }
    .nav-item.active { color: #3b82f6; }
    .nav-item svg { margin-bottom: 4px; width: 20px; height: 20px; }
    .nav-item span { font-size: 10px; font-weight: 800; text-transform: uppercase; letter-spacing: 0.5px; }
  }

  @media (min-width: 769px) {
    .main-container { padding: 24px; }
    .mobile-only { display: none !important; }
    .bottom-nav-bar { display: none !important; }
    .view-conference { display: none !important; } 
    .view-main { display: block !important; } 
    .desktop-controls-wrapper { display: flex; gap: 16px; align-items: flex-end; }
    .mobile-btn-wrapper { display: none !important; } 
    .mobile-filters-panel { display: none !important; } 
    .btn-add-animated { padding: 10px 20px; gap: 8px; } 
    .btn-add-animated span { max-width: 150px; opacity: 1; }
    .kpi-modern-wrapper { flex-direction: row; margin-bottom: 24px; align-items: stretch; }
    .kpi-modern-main { flex: 1.2; padding: 18px 25px; border-right: 1px solid rgba(255,255,255,0.1); }
    .kpi-modern-main-title { font-size: 13px; margin-bottom: 8px; }
    .kpi-modern-main-value { font-size: 48px; }
    .kpi-modern-main-icon { transform: scale(1.6); margin-right: 20px; }
    .kpi-modern-subs { flex: 2; }
    .kpi-modern-sub-card { padding: 24px; gap: 20px; }
    .kpi-modern-sub-icon { width: 48px; height: 48px; }
    .kpi-modern-sub-title { font-size: 12px; margin-bottom: 4px; }
    .kpi-modern-sub-value { font-size: 28px; }
    
    .responsive-table { display: table !important; width: 100%; table-layout: fixed; border-collapse: separate; border-spacing: 0; }
    .responsive-table thead { display: table-header-group !important; }
    .responsive-card { display: table-row-group; }
    .desktop-hidden { display: none !important; }
    .data-row { display: table-row; }
    .responsive-card td { display: table-cell !important; padding: 14px 16px !important; border-bottom: 1px solid #edf2f7 !important; vertical-align: top; text-align: left; font-size: 13px; }
    .mobile-actions-wrapper span { display: none; }
    .mobile-actions-wrapper { display: flex; justify-content: center; gap: 8px; }
  }

  .hidden-record-row { background-color: #f8fafc !important; }
  .hidden-record-row .cadete-header-info, 
  .hidden-record-row .data-row td:not(:last-child) {
      opacity: 0.55;
      filter: grayscale(100%);
  }
`;

// --- ÍCONES ---
const TrashIcon = () => <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><polyline points="3 6 5 6 21 6"></polyline><path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"></path></svg>;
const EditIcon = () => <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"></path><path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"></path></svg>;
const SaveIcon = () => <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M19 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1-2-2h11l5 5v11a2 2 0 0 1-2 2z"></path><polyline points="17 21 17 13 7 13 7 21"></polyline><polyline points="7 3 7 8 15 8"></polyline></svg>;
const CheckCircleIcon = (props) => <svg {...props} width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"></path><polyline points="22 4 12 14.01 9 11.01"></polyline></svg>;
const AlertIcon = (props) => <svg {...props} width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="10"></circle><line x1="12" cy="12" x2="12" y2="12"></line><line x1="12" cy="16" x2="12.01" y2="16"></line></svg>;
const UsersIcon = (props) => <svg {...props} width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"></path><circle cx="9" cy="7" r="4"></circle><path d="M23 21v-2a4 4 0 0 0-3-3.87"></path><path d="M16 3.13a4 4 0 0 1 0 7.75"></path></svg>;
const ChevronLeft = () => <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><polyline points="15 18 9 12 15 6"></polyline></svg>;
const ChevronRight = () => <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><polyline points="9 18 15 12 9 6"></polyline></svg>;
const ArrowDown = () => <svg className="arrow-icon" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><polyline points="6 9 12 15 18 9"></polyline></svg>;
const SettingsIcon = ({ className }) => <svg className={className} width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="3"></circle><path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 0 1 0 2.83 2 2 0 0 1-2.83 0l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-2 2 2 2 0 0 1-2-2v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 0 1-2.83 0 2 2 0 0 1 0-2.83l.06.06a1.65 1.65 0 0 0 .33-1.82 1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1-2-2 2 2 0 0 1 2-2h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 0 1 0-2.83 2 2 0 0 1 2.83 0l.06.06a1.65 1.65 0 0 0 1.82.33H9a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 2-2 2 2 0 0 1 2 2v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 0 1 2.83 0 2 2 0 0 1 0 2.83l-.06.06a1.65 1.65 0 0 0-.33 1.82V9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 2 2 2 2 0 0 1-2 2h-.09a1.65 1.65 0 0 0-1.51 1z"></path></svg>;
const PlusIcon = () => <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round"><line x1="12" y1="5" x2="12" y2="19"></line><line x1="5" y1="12" x2="19" y2="12"></line></svg>;
const ClipboardListIcon = () => <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M16 4h2a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h2"></path><rect x="8" y="2" width="8" height="4" rx="1" ry="1"></rect><path d="M9 14h6"></path><path d="M9 10h6"></path><path d="M9 18h6"></path></svg>;
const CheckSquareIcon = () => <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><polyline points="9 11 12 14 22 4"></polyline><path d="M21 12v7a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11"></path></svg>;
const InfoIcon = () => <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" style={{ flexShrink: 0 }}><circle cx="12" cy="12" r="10"></circle><line x1="12" y1="16" x2="12" y2="12"></line><line x1="12" y1="8" x2="12.01" y2="8"></line></svg>;

const MAPA_HORARIOS = {
    "1º E 2º TEMPOS": { start: "08:15", end: "09:45" },
    "3º E 4º TEMPOS": { start: "10:00", end: "11:30" },
    "5º E 6º TEMPOS": { start: "13:00", end: "14:30" },
    "7º E 8º TEMPOS": { start: "14:45", end: "16:15" },
    "9º E 10º TEMPOS": { start: "16:30", end: "18:00" },
    "PERIODO MATUTINO": { start: "07:00", end: "12:00" },
    "PERIODO VESPERTINO": { start: "12:01", end: "18:00" },
    "PERIODO INTEGRAL": { start: "00:00", end: "23:59" }
};
const OPCOES_FORA_DA_AULA = Object.keys(MAPA_HORARIOS);

const getExpirationString = (motivo) => {
    if (motivo === "1º E 2º TEMPOS") return "09h45";
    if (motivo === "3º E 4º TEMPOS") return "11h30";
    if (motivo === "5º E 6º TEMPOS") return "14h30";
    if (motivo === "7º E 8º TEMPOS") return "16h30";
    if (motivo === "9º E 10º TEMPOS") return "18h00";
    if (motivo === "PERIODO MATUTINO") return "11h30";
    if (motivo === "PERIODO VESPERTINO") return "18h00";
    if (motivo === "PERIODO INTEGRAL") return "23h59";
    return "";
};

const formatDatePTBR = (dateString) => {
    if (!dateString) return '-';
    const [year, month, day] = dateString.split('-');
    return `${day}/${month}/${year}`;
};

const formatLaunchDate = (val) => {
    if (!val) return '';
    let date;
    if (val.seconds) date = new Date(val.seconds * 1000);
    else date = new Date(val);
    
    const day = String(date.getDate()).padStart(2, '0');
    const months = ['JAN', 'FEV', 'MAR', 'ABR', 'MAI', 'JUN', 'JUL', 'AGO', 'SET', 'OUT', 'NOV', 'DEZ'];
    const month = months[date.getMonth()];
    const year = String(date.getFullYear()).slice(-2);
    const hours = String(date.getHours()).padStart(2, '0');
    const minutes = String(date.getMinutes()).padStart(2, '0');
    return `${day}${month}${year} às ${hours}:${minutes}`;
};

const getLocalYYYYMMDD = (date) => {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
};

const getTodayDate = () => getLocalYYYYMMDD(new Date());

const getLastSunday18h = () => {
    const now = new Date();
    const dayOfWeek = now.getDay(); 
    const hours = now.getHours();
    const lastSunday = new Date(now);
    if (dayOfWeek === 0 && hours >= 18) {
        lastSunday.setHours(18, 0, 0, 0);
    } else {
        const daysToSubtract = dayOfWeek === 0 ? 7 : dayOfWeek;
        lastSunday.setDate(now.getDate() - daysToSubtract);
        lastSunday.setHours(18, 0, 0, 0);
    }
    return lastSunday.getTime();
};

const checkIsAtivoForaDaAula = (reg, dataReferenciaStr, listaComplexos = []) => {
    if (listaComplexos.includes(reg.destino) && reg.destino !== 'RESTRIÇÃO') return true;
    if (!reg.isForaDaAula) return false;

    const now = new Date();
    const todayStr = getLocalYYYYMMDD(now);
    let currentHour = now.getHours();
    let currentMinute = now.getMinutes();

    if (dataReferenciaStr < todayStr) { currentHour = 23; currentMinute = 59; } 
    else if (dataReferenciaStr > todayStr) { currentHour = 0; currentMinute = 0; }

    const currentTimeVal = currentHour * 60 + currentMinute;
    const motivo = reg.motivoForaDaAula;
    let expirationTimeVal = 24 * 60; 

    if (motivo === "1º E 2º TEMPOS") expirationTimeVal = 9 * 60 + 45;
    else if (motivo === "3º E 4º TEMPOS") expirationTimeVal = 11 * 60 + 30;
    else if (motivo === "5º E 6º TEMPOS") expirationTimeVal = 14 * 60 + 30;
    else if (motivo === "7º E 8º TEMPOS") expirationTimeVal = 16 * 60 + 30;
    else if (motivo === "9º E 10º TEMPOS") expirationTimeVal = 18 * 60 + 0;
    else if (motivo === "PERIODO MATUTINO") expirationTimeVal = 11 * 60 + 30;
    else if (motivo === "PERIODO VESPERTINO") expirationTimeVal = 18 * 60 + 0;
    else if (motivo === "PERIODO INTEGRAL") expirationTimeVal = 24 * 60;

    return currentTimeVal < expirationTimeVal;
};

const checkIsRecordExpired = (reg, dataReferenciaStr) => {
    const now = new Date();
    const todayStr = getLocalYYYYMMDD(now);
    let currentHour = now.getHours();
    let currentMinute = now.getMinutes();

    if (dataReferenciaStr < todayStr) { currentHour = 23; currentMinute = 59; } 
    else if (dataReferenciaStr > todayStr) { currentHour = 0; currentMinute = 0; }

    const currentTimeVal = currentHour * 60 + currentMinute;

    if (reg.expiraAs) {
        const [expH, expM] = reg.expiraAs.split(':').map(Number);
        const expTimeVal = expH * 60 + expM;
        if (currentTimeVal >= expTimeVal) return true;
    }

    if (reg.isForaDaAula) {
        const motivo = reg.motivoForaDaAula;
        let expirationTimeVal = 24 * 60; 

        if (motivo === "1º E 2º TEMPOS") expirationTimeVal = 9 * 60 + 45;
        else if (motivo === "3º E 4º TEMPOS") expirationTimeVal = 11 * 60 + 30;
        else if (motivo === "5º E 6º TEMPOS") expirationTimeVal = 14 * 60 + 30;
        else if (motivo === "7º E 8º TEMPOS") expirationTimeVal = 16 * 60 + 30;
        else if (motivo === "9º E 10º TEMPOS") expirationTimeVal = 18 * 60 + 0;
        else if (motivo === "PERIODO MATUTINO") expirationTimeVal = 11 * 60 + 30;
        else if (motivo === "PERIODO VESPERTINO") expirationTimeVal = 18 * 60 + 0;
        else if (motivo === "PERIODO INTEGRAL") expirationTimeVal = 24 * 60;

        if (currentTimeVal >= expirationTimeVal) return true;
    }

    return false;
};

const isRecordVisibleByTimeRules = (reg, dataReferenciaStr, listaComplexos = []) => {
    const now = new Date();
    const todayStr = getLocalYYYYMMDD(now);
    let currentHour = now.getHours();
    let currentMinute = now.getMinutes();

    if (dataReferenciaStr < todayStr) { currentHour = 23; currentMinute = 59; } 
    else if (dataReferenciaStr > todayStr) { currentHour = 0; currentMinute = 0; }

    const currentTimeVal = currentHour * 60 + currentMinute;

    if (reg.expiraAs) {
        const [expH, expM] = reg.expiraAs.split(':').map(Number);
        const expTimeVal = expH * 60 + expM;
        if (currentTimeVal >= expTimeVal) return false;
        // Permite passar para avaliação de horário de instrução
    }

    if (listaComplexos.includes(reg.destino)) return true; 

    if (!reg.isForaDaAula) {
        const isMorningBlock = currentTimeVal >= (8 * 60 + 15) && currentTimeVal <= (11 * 60 + 30);
        const isAfternoonBlock = currentTimeVal >= (13 * 60 + 0) && currentTimeVal <= (16 * 60 + 30);
        if (isMorningBlock || isAfternoonBlock) return false;
    } else {
        const motivo = reg.motivoForaDaAula;
        let expirationTimeVal = 24 * 60; 

        if (motivo === "1º E 2º TEMPOS") expirationTimeVal = 9 * 60 + 45;
        else if (motivo === "3º E 4º TEMPOS") expirationTimeVal = 11 * 60 + 30;
        else if (motivo === "5º E 6º TEMPOS") expirationTimeVal = 14 * 60 + 30;
        else if (motivo === "7º E 8º TEMPOS") expirationTimeVal = 16 * 60 + 30;
        else if (motivo === "9º E 10º TEMPOS") expirationTimeVal = 18 * 60 + 0;
        else if (motivo === "PERIODO MATUTINO") expirationTimeVal = 11 * 60 + 30;
        else if (motivo === "PERIODO VESPERTINO") expirationTimeVal = 18 * 60 + 0;
        else if (motivo === "PERIODO INTEGRAL") expirationTimeVal = 24 * 60;

        if (currentTimeVal >= expirationTimeVal) return false;
    }
    return true;
};

const ResultadoOnlinePage = () => {
  const { userProfile } = useAuth();
  const userPelotao = userProfile?.pelotao_nome || userProfile?.pelotao || '';
  
  const [dataReferencia, setDataReferencia] = useState(getTodayDate());
  const [cadetesPelotao, setCadetesPelotao] = useState([]);
  const [todosRegistrosPelotao, setTodosRegistrosPelotao] = useState([]);
  const [liderancaTurma, setLiderancaTurma] = useState({ chefe: '', subChefe: '' });
  const [nomeTurma, setNomeTurma] = useState('');
  const [loadingConfig, setLoadingConfig] = useState(true);
  
  const [showFilters, setShowFilters] = useState(false);
  const [listaDestinosSimples, setListaDestinosSimples] = useState([]);
  const [listaDestinosComplexos, setListaDestinosComplexos] = useState([]);
  const [listaGremios, setListaGremios] = useState([]);
  const [listaEquipes, setListaEquipes] = useState([]);

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [formStep, setFormStep] = useState(1); 
  const [showTemporario, setShowTemporario] = useState(false); 
  const [loading, setLoading] = useState(false);
  const [editingId, setEditingId] = useState(null);
  const [expandedId, setExpandedId] = useState(null);
  
  const [showHiddenRecords, setShowHiddenRecords] = useState(false);

  const [isMultiSelect, setIsMultiSelect] = useState(false);
  const [showPendingOnly, setShowPendingOnly] = useState(false);
  const [originalRecord, setOriginalRecord] = useState(null);

  const [activeTab, setActiveTab] = useState('main'); 
  const [touchStart, setTouchStart] = useState(null);
  const [touchEnd, setTouchEnd] = useState(null);
  const minSwipeDistance = 50;

  const [timeTicker, setTimeTicker] = useState(0);

  useEffect(() => {
      const timer = setInterval(() => { setTimeTicker(t => t + 1); }, 60000); 
      return () => clearInterval(timer);
  }, []);

  const getInitialFormState = () => ({
    cadeteId: '', 
    cadetesIds: [],
    destino: '', 
    qru_motivo: '', qth_endereco: '', situacao: '', informacoes_complementares: '',
    periodo_inicio: dataReferencia, periodo_fim: dataReferencia, dias_quantidade: 1,
    isForaDaAula: false, motivoForaDaAula: '',
    expiraAs: '',
    destinoTemporario: '', 
    detalheTemporario: ''  
  });

  const [form, setForm] = useState(getInitialFormState());

  const destinosComDataExtra = ['AUX CMT CIA', 'AUX CMT PEL'];

  useEffect(() => {
    const fetchConfig = async () => {
      setLoadingConfig(true);
      try {
        const destRef = doc(db, 'artifacts', 'app-estagios', 'public', 'data', 'config_geral', 'destinos_opcoes');
        const destSnap = await getDoc(destRef);
        if (destSnap.exists()) {
          const d = destSnap.data();
          setListaDestinosSimples(d.simples || []);
          setListaDestinosComplexos(d.complexos || []);
        }
        const gremiosRef = doc(db, 'artifacts', 'app-estagios', 'public', 'data', 'config_geral', 'gremios_opcoes');
        const gremiosSnap = await getDoc(gremiosRef);
        if (gremiosSnap.exists()) {
          setListaGremios(gremiosSnap.data().gremios || []);
          setListaEquipes(gremiosSnap.data().equipes || []);
        }
        if (userPelotao) {
            const pelRef = collection(db, 'artifacts', 'app-estagios', 'public', 'data', 'pelotoes');
            const q = query(pelRef, where('nome', '==', userPelotao));
            const snap = await getDocs(q);
            if (!snap.empty) {
                const pelData = snap.docs[0].data();
                setNomeTurma(pelData.turma || pelData.turma_nome || '');
            }
        }
      } catch (e) { console.error(e); }
      setLoadingConfig(false);
    };
    fetchConfig();
  }, [userPelotao]);

  useEffect(() => {
    if (!userPelotao) return;
    const unsubUsers = onSnapshot(query(collection(db, paths.users), where('pelotao_nome', '==', userPelotao)), (snap) => {
      const data = snap.docs.map(d => ({ id: d.id, ...d.data() }));
      setCadetesPelotao(data.filter(u => ['cadete', 'cadete_academico', 'escalante', 'aspirante'].includes(u.nivel)));
    });
    
    const unsubLider = onSnapshot(doc(db, paths.lideranca_pelotoes, userPelotao), (snap) => {
      if (snap.exists()) {
          const data = snap.data();
          const limiteExpiracao = getLastSunday18h();
          if (!data.timestamp || data.timestamp < limiteExpiracao) { setLiderancaTurma({ chefe: '', subChefe: '' }); } 
          else { setLiderancaTurma(data); }
      } else {
          setLiderancaTurma({ chefe: '', subChefe: '' });
      }
    });

    const unsubRegs = onSnapshot(query(collection(db, paths.resultado_online), where('pelotao', '==', userPelotao)), (snap) => {
      setTodosRegistrosPelotao(snap.docs.map(d => {
          const data = d.data();
          const { id, ...cleanData } = data; 
          return { ...cleanData, id: d.id }; 
      }));
    });
    return () => { unsubUsers(); unsubLider(); unsubRegs(); };
  }, [userPelotao]);

  const sortedCadetes = useMemo(() => {
    return [...cadetesPelotao].sort((a, b) => {
        const nameA = (a.nome_guerra || a.nome || '').trim();
        const nameB = (b.nome_guerra || b.nome || '').trim();
        return nameA.localeCompare(nameB, 'pt-BR', { sensitivity: 'base' });
    });
  }, [cadetesPelotao]);

  const validRegistrations = useMemo(() => {
    const dataFiltro = dataReferencia;
    return todosRegistrosPelotao.filter(reg => 
        reg.periodo_inicio <= dataFiltro && 
        reg.periodo_fim >= dataFiltro
    );
  }, [todosRegistrosPelotao, dataReferencia]);

  const { visibleList, hiddenList } = useMemo(() => {
    const grouped = {};
    validRegistrations.forEach(reg => {
        const key = reg.cadeteId || reg.cadeteNome;
        if (!grouped[key]) grouped[key] = [];
        grouped[key].push(reg);
    });

    let finalList = [];
    Object.values(grouped).forEach(group => {
        group.sort((a, b) => {
            const timeA = a.timestamp?.seconds || 0;
            const timeB = b.timestamp?.seconds || 0;
            return timeB - timeA;
        });

        const restricaoRecord = group.find(r => r.destino === 'RESTRIÇÃO');
        if (restricaoRecord) {
            finalList.push(restricaoRecord);
            const newestOther = group.find(r => r.id !== restricaoRecord.id);
            if (newestOther) finalList.push(newestOther);
        } else {
            if (group.length > 0) finalList.push(group[0]);
        }
    });

    const vis = [];
    const hid = [];
    
    const now = new Date();
    const todayStr = getLocalYYYYMMDD(now);
    let currentHour = now.getHours();
    let currentMinute = now.getMinutes();
    if (dataReferencia < todayStr) { currentHour = 23; currentMinute = 59; } 
    else if (dataReferencia > todayStr) { currentHour = 0; currentMinute = 0; }
    const currentTimeVal = currentHour * 60 + currentMinute;
    
    const isMorningBlock = currentTimeVal >= (8 * 60 + 15) && currentTimeVal <= (11 * 60 + 30);
    const isAfternoonBlock = currentTimeVal >= (13 * 60 + 0) && currentTimeVal <= (16 * 60 + 30);
    
    const isTempTime = dataReferencia === todayStr && currentTimeVal >= (16 * 60 + 28) && currentTimeVal < (17 * 60 + 40);

    finalList.forEach(originalReg => {
        let reg = { ...originalReg };

        const isExpired = checkIsRecordExpired(originalReg, dataReferencia);

        if (isTempTime && reg.destinoTemporario && reg.detalheTemporario && !isExpired) {
            reg.destinoOriginal = reg.destino;
            reg.destino = reg.destinoTemporario;
            reg.informacoes_complementares = reg.detalheTemporario;
            reg.isTemporarioAtivo = true;
            reg.isForaDaAula = false; 
            reg.expiraAs = ''; 
        }

        if (isRecordVisibleByTimeRules(reg, dataReferencia, listaDestinosComplexos)) {
            vis.push(reg);
        } else {
            if (!isExpired) {
                const isHiddenByInstruction = !listaDestinosComplexos.includes(reg.destino) && !reg.isForaDaAula;
                if (isHiddenByInstruction && (isMorningBlock || isAfternoonBlock)) {
                    hid.push(reg);
                }
            }
        }
    });

    const sortAlphabetically = (a, b) => {
        const nameA = (a.cadeteNome || '').trim();
        const nameB = (b.cadeteNome || '').trim();
        return nameA.localeCompare(nameB, 'pt-BR', { sensitivity: 'base' });
    };

    vis.sort(sortAlphabetically);
    hid.sort(sortAlphabetically);

    return { visibleList: vis, hiddenList: hid };
  }, [validRegistrations, dataReferencia, timeTicker, listaDestinosComplexos]);

  const qtdAusentesUnicos = useMemo(() => {
      const idsUnicos = new Set();
      visibleList.forEach(reg => {
          if (reg.cadeteId) idsUnicos.add(reg.cadeteId);
          else if (reg.cadeteNome) idsUnicos.add(reg.cadeteNome);
      });
      return idsUnicos.size;
  }, [visibleList]);

  const cadetesDisponiveis = useMemo(() => {
    return sortedCadetes.filter(cadete => {
        if (editingId && form.cadeteId === cadete.id) return true;
        const activeRecords = validRegistrations.filter(reg => {
            const isMyRecord = reg.cadeteId === cadete.id || 
                               reg.cadeteNome === cadete.nome_guerra || 
                               reg.cadeteNome === cadete.nome;
            if (!isMyRecord) return false;
            return !checkIsRecordExpired(reg, dataReferencia);
        });
        if (showPendingOnly) return activeRecords.length === 0;
        return activeRecords.length < 2;
    });
  }, [sortedCadetes, validRegistrations, editingId, form.cadeteId, showPendingOnly, dataReferencia, timeTicker]);

  const cadetesProntos = useMemo(() => {
    return sortedCadetes.filter(cadete => {
        const isAusenteVisivel = visibleList.some(reg => 
            reg.cadeteId === cadete.id || 
            reg.cadeteNome === cadete.nome_guerra || 
            reg.cadeteNome === cadete.nome
        );
        return !isAusenteVisivel;
    });
  }, [sortedCadetes, visibleList]);

  const hiddenReturnTime = useMemo(() => {
      if (hiddenList.length === 0) return null;
      const now = new Date();
      const currentHour = now.getHours();
      const currentMinute = now.getMinutes();
      const currentTimeVal = currentHour * 60 + currentMinute;

      if (currentTimeVal >= (8 * 60 + 15) && currentTimeVal <= (11 * 60 + 30)) return "11h31";
      if (currentTimeVal >= (13 * 60 + 0) && currentTimeVal <= (16 * 60 + 30)) return "16h31";
      return "em breve";
  }, [hiddenList.length, timeTicker]);

  const onTouchStart = (e) => { setTouchEnd(null); setTouchStart(e.targetTouches[0].clientX); };
  const onTouchMove = (e) => { setTouchEnd(e.targetTouches[0].clientX); };

  const onTouchEndAction = () => {
      if (!touchStart || !touchEnd || isModalOpen) return;
      const distance = touchStart - touchEnd;
      if (distance > minSwipeDistance && activeTab === 'main') setActiveTab('conference');
      if (distance < -minSwipeDistance && activeTab === 'conference') setActiveTab('main');
  };

  const handlePrevDay = () => {
      const [year, month, day] = dataReferencia.split('-');
      const d = new Date(year, month - 1, day);
      d.setDate(d.getDate() - 1);
      setDataReferencia(getLocalYYYYMMDD(d));
  };
  
  const handleNextDay = () => {
      const [year, month, day] = dataReferencia.split('-');
      const d = new Date(year, month - 1, day);
      d.setDate(d.getDate() + 1);
      setDataReferencia(getLocalYYYYMMDD(d));
  };

  const handleOpenModal = () => {
    if (!liderancaTurma.chefe || !liderancaTurma.subChefe) {
        setShowFilters(true);
        return alert('Atenção: Defina a chefia do pelotão! (O sistema reseta a chefia automaticamente todo domingo às 18h00).');
    }
    setEditingId(null); 
    setOriginalRecord(null);
    setForm(getInitialFormState()); 
    setIsMultiSelect(false);
    setShowPendingOnly(false);
    setShowTemporario(false); 
    setFormStep(1); 
    setIsModalOpen(true);
  };

  const handleEdit = (reg) => {
    setEditingId(reg.id); 
    setOriginalRecord(reg);
    const { id, ...dataToEdit } = reg;
    setForm({ 
        ...dataToEdit, 
        cadeteId: cadetesPelotao.find(c => c.nome === reg.cadeteNome || c.nome_guerra === reg.cadeteNome)?.id || '',
        destinoTemporario: reg.destinoTemporario || '', 
        detalheTemporario: reg.detalheTemporario || '' 
    });
    setIsMultiSelect(false);
    setShowTemporario(!!reg.destinoTemporario); 
    setFormStep(1); 
    setIsModalOpen(true);
  };

  const handleSmartDelete = async (reg) => {
      if(!window.confirm("Confirmar exclusão?")) return;
      setLoading(true);
      try {
          const idsToDelete = new Set([reg.id]);
          const ghosts = todosRegistrosPelotao.filter(r => 
              (r.cadeteId === reg.cadeteId || r.cadeteNome === reg.cadeteNome) && 
              r.periodo_inicio <= dataReferencia && r.periodo_fim >= dataReferencia &&
              r.status !== 'historico' && r.id !== reg.id 
          );

          if (reg.destino === 'RESTRIÇÃO') {
              ghosts.filter(r => r.destino === 'RESTRIÇÃO').forEach(g => idsToDelete.add(g.id));
          } else {
              ghosts.filter(r => r.destino !== 'RESTRIÇÃO').forEach(g => idsToDelete.add(g.id));
          }

          const deletePromises = Array.from(idsToDelete).map(id => deleteDoc(doc(db, paths.resultado_online, id)));
          await Promise.all(deletePromises);
      } catch (e) {
          console.error(e); alert("Erro ao excluir.");
      } finally { setLoading(false); }
  };

  const handleFormChange = (fld, val) => {
    setForm(prev => {
      const upd = { ...prev, [fld]: val };
      if (fld === 'destino') {
          if (val === 'GRÊMIOS' && !listaGremios.includes(upd.informacoes_complementares)) upd.informacoes_complementares = '';
          else if (val === 'EQUIPES' && !listaEquipes.includes(upd.informacoes_complementares)) upd.informacoes_complementares = '';
          
          if (!listaDestinosSimples.includes(val) && val !== 'RESTRIÇÃO') {
             upd.isForaDaAula = false;
             upd.motivoForaDaAula = '';
             upd.expiraAs = ''; 
          }
      }
      if (fld === 'periodo_inicio' || fld === 'periodo_fim') {
        const diff = new Date(upd.periodo_fim) - new Date(upd.periodo_inicio);
        upd.dias_quantidade = Math.max(0, Math.ceil(diff / 86400000) + 1);
      }
      return upd;
    });
  };

  const toggleCadeteSelection = (id) => {
      setForm(prev => {
          const currentIds = prev.cadetesIds || [];
          if (currentIds.includes(id)) { return { ...prev, cadetesIds: currentIds.filter(cid => cid !== id) }; } 
          else { return { ...prev, cadetesIds: [...currentIds, id] }; }
      });
  };

  const handleToggleForaDaAula = () => {
    setForm(prev => ({ ...prev, isForaDaAula: !prev.isForaDaAula, motivoForaDaAula: !prev.isForaDaAula ? prev.motivoForaDaAula : '' }));
  };
  
  const toggleTemporarioAccordion = () => {
      if (showTemporario) {
          handleFormChange('destinoTemporario', '');
          handleFormChange('detalheTemporario', '');
      }
      setShowTemporario(!showTemporario);
  };

  const handleInitialSubmit = (e) => {
    e.preventDefault();
    if (!form.destino) return alert("Preencha o Destino principal.");
    
    if (listaDestinosSimples.includes(form.destino) && !['GRÊMIOS', 'EQUIPES'].includes(form.destino) && !form.informacoes_complementares) {
      return alert("Preencha as Informações Complementares.");
    }
    if (listaDestinosComplexos.includes(form.destino) && (!form.qru_motivo || !form.situacao || !form.qth_endereco)) {
        return alert("Para destinos detalhados, preencha Motivo, Situação e Endereço.");
    }

    const requiresForaDaAulaConfirmation = listaDestinosSimples.includes(form.destino) || form.destino === 'RESTRIÇÃO';

    if (requiresForaDaAulaConfirmation) {
        setFormStep(2); 
    } else {
        executeSave(); 
    }
  };

  const executeSave = async () => {
    if (formStep === 2 && form.isForaDaAula && !form.motivoForaDaAula) {
        return alert("Por favor, selecione o período para a opção Fora da Aula.");
    }

    setLoading(true);
    try {
      const executorNomeGuerra = userProfile?.nome_guerra ? `Cad PM ${userProfile.nome_guerra}` : 'Não identificado';
      const { id, ...finalPayload } = form;
      
      if (!listaDestinosSimples.includes(finalPayload.destino) && finalPayload.destino !== 'RESTRIÇÃO') {
         finalPayload.isForaDaAula = false;
         finalPayload.motivoForaDaAula = '';
         finalPayload.expiraAs = '';
      }

      if (editingId) {
          const basePayload = { 
              ...finalPayload, editadoPor: userProfile.id, nome_guerra_executor: executorNomeGuerra, timestamp: new Date()
          };
          delete basePayload.id; delete basePayload.cadetesIds;
          await updateDoc(doc(db, paths.resultado_online, editingId), basePayload);
      } 
      else {
          let targetIds = [];
          if (isMultiSelect) {
             targetIds = form.cadetesIds;
             if (targetIds.length === 0) return alert("Selecione pelo menos um Cadete.");
          } else {
             if (!form.cadeteId) return alert("Selecione o Cadete.");
             targetIds = [form.cadeteId];
          }

          const promises = targetIds.map(async (targetId) => {
              const cadeteObj = cadetesPelotao.find(c => c.id === targetId);
              const cadeteNome = cadeteObj?.nome_guerra || cadeteObj?.nome || 'Desconhecido';
              
              const payload = { 
                  ...finalPayload, cadeteId: targetId, pelotao: userPelotao, cadeteNome, criadoPor: userProfile.id, nome_guerra_executor: executorNomeGuerra, timestamp: new Date(), status: 'ativo'
              };
              delete payload.id; delete payload.cadetesIds; 
              return addDoc(collection(db, paths.resultado_online), payload);
          });
          await Promise.all(promises);
      }
      setIsModalOpen(false);
    } catch (err) { 
        console.error(err); alert("Erro ao salvar."); 
    } finally { setLoading(false); }
  };

  const handleSaveLideranca = async () => {
    if (!userPelotao) return alert("Sem Pelotão definido.");
    if (!liderancaTurma.chefe || !liderancaTurma.subChefe) return alert("Selecione o Chefe e o Sub-Chefe para salvar.");
    try { 
        await setDoc(doc(db, paths.lideranca_pelotoes, userPelotao), { ...liderancaTurma, timestamp: new Date().getTime() }); 
        alert('Liderança do Pelotão definida!'); 
    } catch (e) { console.error(e); }
  };

  const setQuickDuration = (days) => {
      const [year, month, day] = form.periodo_inicio.split('-');
      const start = new Date(year, month - 1, day);
      start.setDate(start.getDate() + days);
      handleFormChange('periodo_fim', getLocalYYYYMMDD(start));
  };

  const controlesDataLideranca = (
    <>
        <div style={{ flex: 1, minWidth: '220px' }}>
            <label className="modern-label" style={{ marginBottom: '6px' }}>Data de Referência</label>
            <div style={{ display: 'flex', alignItems: 'center', gap: '8px', backgroundColor: '#f8fafc', padding: '6px 12px', borderRadius: '8px', border: dataReferencia === getTodayDate() ? '1px solid #e2e8f0' : '1px solid #f6ad55', height: '40px', boxSizing: 'border-box' }}>
                <button onClick={handlePrevDay} style={{ border: 'none', background: '#e2e8f0', borderRadius: '50%', width: '28px', height: '28px', cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}><ChevronLeft /></button>
                <input type="date" value={dataReferencia} onChange={(e) => setDataReferencia(e.target.value)} style={{ border: 'none', fontWeight: '700', outline: 'none', textAlign: 'center', cursor: 'pointer', fontSize: '13px', background: 'transparent', width: '100%', minWidth: '110px' }} />
                <button onClick={handleNextDay} style={{ border: 'none', background: '#e2e8f0', borderRadius: '50%', width: '28px', height: '28px', cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}><ChevronRight /></button>
            </div>
        </div>
        <div className="leadership-container" style={{ flex: 2, margin: 0, padding: 0, border: 'none', boxShadow: 'none', backgroundColor: 'transparent' }}>
            <div className="leadership-item">
                <label className="leadership-label modern-label" style={{marginBottom: '6px'}}>Chefe</label>
                <select className="modern-input" value={liderancaTurma.chefe} onChange={(e) => setLiderancaTurma({...liderancaTurma, chefe: e.target.value})} style={{ height: '40px', fontSize: '11px', fontWeight: '600' }}>
                    <option value="">Selecione...</option>
                    {sortedCadetes.map(c => <option key={c.id} value={c.nome_guerra || c.nome}>{c.nome_guerra || c.nome}</option>)}
                </select>
            </div>
            <div className="leadership-item">
                <label className="leadership-label modern-label" style={{marginBottom: '6px'}}>Sub-Chefe</label>
                <select className="modern-input" value={liderancaTurma.subChefe} onChange={(e) => setLiderancaTurma({...liderancaTurma, subChefe: e.target.value})} style={{ height: '40px', fontSize: '11px', fontWeight: '600' }}>
                    <option value="">Selecione...</option>
                    {sortedCadetes.map(c => <option key={c.id} value={c.nome_guerra || c.nome}>{c.nome_guerra || c.nome}</option>)}
                </select>
            </div>
            <button onClick={handleSaveLideranca} className="modern-btn-primary" style={{ width: '40px', height: '40px', padding: '0', display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }} title="Salvar Liderança">
                <SaveIcon />
            </button>
        </div>
    </>
  );

  return (
    <div 
      className="main-container" 
      onTouchStart={onTouchStart} 
      onTouchMove={onTouchMove} 
      onTouchEnd={onTouchEndAction}
    >
      <style>{styleTag}</style>
      
      <div className="mobile-stack" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-end', marginBottom: '16px', flexWrap: 'wrap', gap: '16px' }}>
        <div className="mobile-header-text">
            <h1 style={{ margin: 0, color: '#1a202c', fontSize: '22px', fontWeight: '800' }}>Resultado Online</h1>
            <div style={{ display: 'flex', alignItems: 'center', gap: '8px', marginTop: '4px' }}>
                <span style={{ fontSize: '13px', fontWeight: '600', color: '#2b6cb0', backgroundColor: '#ebf8ff', padding: '2px 8px', borderRadius: '4px' }}>{userPelotao || 'ND'}</span>
                <span style={{ fontSize: '12px', color: '#718096' }}>{loadingConfig ? '• Carregando...' : (nomeTurma ? `• ${nomeTurma}` : '• Sem Turma')}</span>
            </div>
        </div>
        <div className="desktop-controls-wrapper">{controlesDataLideranca}</div>
        <div className="mobile-btn-wrapper">
            <button onClick={() => setShowFilters(!showFilters)} className="filter-toggle-btn" style={{ borderColor: showFilters ? '#38a169' : '#e2e8f0', color: showFilters ? '#38a169' : '#4a5568', backgroundColor: showFilters ? '#f0fdf4' : 'white' }}>
              <SettingsIcon className={`gear-animated ${showFilters ? 'open' : 'closed'}`} />
            </button>
        </div>
      </div>

      {showFilters && (<div className="filters-panel mobile-filters-panel"><div style={{ display: 'flex', flexDirection: 'column', gap: '16px', alignItems: 'stretch' }}>{controlesDataLideranca}</div></div>)}

      {/* --- MENU INFERIOR MOBILE (Navegação App-like) --- */}
      <div className="bottom-nav-bar">
          <div className={`nav-item ${activeTab === 'main' ? 'active' : ''}`} onClick={() => setActiveTab('main')}>
              <ClipboardListIcon />
              <span>Lançamentos</span>
          </div>
          <div className={`nav-item ${activeTab === 'conference' ? 'active' : ''}`} onClick={() => setActiveTab('conference')}>
              <CheckSquareIcon />
              <span>Conferência</span>
          </div>
      </div>

      {/* --- VIEW 1: TELA PRINCIPAL DE LANÇAMENTOS --- */}
      <div className={`view-main ${activeTab !== 'main' ? 'hidden-mobile' : ''}`}>
          
          <div className="kpi-modern-wrapper">
            <div className="kpi-modern-main">
                <div style={{ zIndex: 1 }}>
                    <div className="kpi-modern-main-title">Efetivo Pronto</div>
                    <div className="kpi-modern-main-value">{cadetesPelotao.length - qtdAusentesUnicos}</div>
                </div>
                <div className="kpi-modern-main-icon">
                    <CheckCircleIcon style={{ width: 64, height: 64 }} />
                </div>
            </div>

            <div className="kpi-modern-subs">
                <div className="kpi-modern-sub-card">
                    <div className="kpi-modern-sub-icon" style={{ backgroundColor: '#eff6ff', color: '#3b82f6' }}>
                        <UsersIcon />
                    </div>
                    <div>
                        <div className="kpi-modern-sub-title">Efetivo Total</div>
                        <div className="kpi-modern-sub-value">{cadetesPelotao.length}</div>
                    </div>
                </div>

                <div className="kpi-modern-sub-card">
                    <div className="kpi-modern-sub-icon" style={{ backgroundColor: '#fef2f2', color: '#ef4444' }}>
                        <AlertIcon width="24" height="24" />
                    </div>
                    <div>
                        <div className="kpi-modern-sub-title">Novidades</div>
                        <div className="kpi-modern-sub-value">{qtdAusentesUnicos}</div>
                    </div>
                </div>
            </div>
          </div>

          <div style={{ backgroundColor: 'white', borderRadius: '10px', padding: window.innerWidth < 768 ? '8px' : '16px', boxShadow: '0 2px 4px rgba(0,0,0,0.05)', border: '1px solid #e2e8f0', overflow: 'hidden' }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '16px', alignItems: 'center' }}>
                <span className="mobile-only" style={{ fontWeight: '800', fontSize: '15px', color: '#1e293b', marginLeft: '4px' }}>Registros:</span>
                <button onClick={handleOpenModal} className="btn-add-animated" title="Inserir Resultado" style={{ marginLeft: 'auto' }}>
               <PlusIcon /><span>Inserir Resultado</span>
             </button>
            </div>

            <table className="responsive-table">
                <thead className="desktop-only">
                    <tr style={{ background: '#f8fafc', color: '#64748b', fontSize: '11px', textAlign: 'left', textTransform: 'uppercase' }}>
                        <th style={{ padding: '10px 12px', borderBottom: '1px solid #e2e8f0', width: '20%' }}>Cadete</th>
                        <th style={{ padding: '10px 12px', borderBottom: '1px solid #e2e8f0', width: '15%' }}>Destino</th>
                        <th style={{ padding: '10px 12px', borderBottom: '1px solid #e2e8f0', width: '40%' }}>Detalhes</th>
                        <th style={{ padding: '10px 12px', borderBottom: '1px solid #e2e8f0', width: '15%' }}>Período</th>
                        <th style={{ padding: '10px 12px', borderBottom: '1px solid #e2e8f0', width: '10%', textAlign:'center' }}>Ações</th>
                    </tr>
                </thead>
                {visibleList.length === 0 ? (
                    <tbody>
                        <tr>
                            <td colSpan="5" style={{ borderBottom: 'none' }}>
                                <div style={{ textAlign: 'center', padding: '20px 16px', color: '#a0aec0', fontSize: '13px', width: '100%', boxSizing: 'border-box' }}>
                                    O pelotão está sem novidades.
                                </div>
                            </td>
                        </tr>
                    </tbody>
                ) : (
                    visibleList.map(reg => {
                        const isComplexo = listaDestinosComplexos.includes(reg.destinoOriginal || reg.destino);
                        const isRestricao = reg.destino === 'RESTRIÇÃO';
                        const isForaAtivo = checkIsAtivoForaDaAula(reg, dataReferencia, listaDestinosComplexos);
                        
                        const labelFora = (isComplexo && !isRestricao) ? '[FORA DE AULA]' : `[FORA DE AULA]: ${reg.motivoForaDaAula}`;
                        
                        let nomeLancador = reg.nome_guerra_executor;
                        if (!nomeLancador || nomeLancador === 'Não identificado') {
                            const executorUser = cadetesPelotao.find(c => c.id === (reg.editadoPor || reg.criadoPor));
                            if (executorUser) {
                                nomeLancador = executorUser.nome_guerra ? `Cad PM ${executorUser.nome_guerra}` : `Cad PM ${executorUser.nome}`;
                            } else {
                                nomeLancador = 'Não identificado';
                            }
                        }

                        return (
                            <tbody key={reg.id} className={`responsive-card ${expandedId === reg.id ? 'expanded' : ''}`}>
                                <tr className="mobile-header-row desktop-hidden" onClick={() => setExpandedId(expandedId === reg.id ? null : reg.id)}>
                                    <td colSpan="5">
                                        <div className="cadete-header">
                                            <div className="cadete-header-info">
                                                <span className="cadete-name-mobile" title={`Cad ${reg.cadeteNome}`}>{`Cad ${reg.cadeteNome}`}</span>
                                                <span className="cadete-tag-mobile" style={{ backgroundColor: reg.isTemporarioAtivo ? '#faf5ff' : (isComplexo ? '#fef2f2' : '#eff6ff'), color: reg.isTemporarioAtivo ? '#6b46c1' : (isComplexo ? '#ef4444' : '#3b82f6') }}>
                                                    {reg.destino}
                                                </span>
                                            </div>
                                            <div className="arrow-icon"><ArrowDown /></div>
                                        </div>
                                    </td>
                                </tr>
                                <tr className="data-row">
                                    <td data-label="Cadete" className="desktop-only-cell" style={{ fontWeight: '700', color: '#1e293b' }}>
                                        {`Cad ${reg.cadeteNome}`}
                                    </td>
                                    <td data-label="Destino" className="desktop-only-cell">
                                        <span style={{ padding: '4px 8px', borderRadius: '12px', fontSize: '10px', backgroundColor: reg.isTemporarioAtivo ? '#faf5ff' : (isComplexo ? '#fef2f2' : '#eff6ff'), color: reg.isTemporarioAtivo ? '#6b46c1' : (isComplexo ? '#ef4444' : '#3b82f6'), fontWeight: '800' }}>
                                            {reg.destino}
                                        </span>
                                    </td>
                                    <td data-label="Detalhes" style={{ color: '#475569' }}>
                                        <div>
                                            {isComplexo && !reg.isTemporarioAtivo ? (
                                                <>
                                                    {reg.qru_motivo && <div style={{marginBottom: '2px'}}><strong style={{color:'#1e293b'}}>Motivo:</strong> {reg.qru_motivo}</div>}
                                                    {reg.situacao && <div style={{marginBottom: '2px'}}><strong style={{color:'#1e293b'}}>Situação:</strong> {reg.situacao}</div>}
                                                    {reg.qth_endereco && <div><strong style={{color:'#1e293b'}}>Endereço:</strong> {reg.qth_endereco}</div>}
                                                </>
                                            ) : (
                                                <div style={{ fontWeight: reg.isTemporarioAtivo ? '700' : '400' }}>{reg.informacoes_complementares || '-'}</div>
                                            )}
                                            
                                            {reg.isTemporarioAtivo && (
                                                <div style={{ color: '#6b46c1', fontWeight: '800', fontSize: '9px', marginTop: '4px', backgroundColor: '#faf5ff', padding: '4px 8px', borderRadius: '4px', display: 'inline-block', border: '1px solid #e9d8fd' }}>
                                                    ⏳ ATIVIDADE TEMPORÁRIA (16h28 às 17h40)
                                                </div>
                                            )}

                                            {!reg.isTemporarioAtivo && reg.destinoTemporario && reg.detalheTemporario && (
                                                <div style={{ color: '#805ad5', fontWeight: '700', fontSize: '10px', marginTop: '4px' }}>
                                                    [🕒 AGENDADO: {reg.destinoTemporario} ({reg.detalheTemporario}) 16h28 - 17h40]
                                                </div>
                                            )}

                                            {!reg.isTemporarioAtivo && isForaAtivo && <div style={{ color: '#ef4444', fontWeight: '700', fontSize: '10px', marginTop: '4px' }}>{labelFora}</div>}
                                            {reg.expiraAs && <div style={{ color: '#dd6b20', fontWeight: '700', fontSize: '10px', marginTop: '4px' }}>[EXPIRA ÀS: {reg.expiraAs}]</div>}
                                            
                                            <div style={{ fontSize: '9px', color: '#94a3b8', marginTop: '4px' }}>
                                                Lançado por: {nomeLancador} em: {formatLaunchDate(reg.timestamp)}
                                            </div>
                                        </div>
                                    </td>
                                    <td data-label="Período" style={{ color: '#475569' }}>
                                        {formatDatePTBR(reg.periodo_inicio)} - {formatDatePTBR(reg.periodo_fim)}
                                    </td>
                                    <td data-label="Ações" style={{ textAlign: 'center' }}>
                                        <div className="mobile-actions-wrapper">
                                            <button onClick={() => handleEdit(reg)} style={{ color: '#3b82f6', background: '#eff6ff', border: 'none', padding: '6px 12px', borderRadius: '6px', cursor: 'pointer', transition: 'background 0.2s', display: 'flex', alignItems: 'center', gap: '4px', fontWeight: 'bold' }}>
                                                <EditIcon /> <span>Editar</span>
                                            </button>
                                            <button onClick={() => handleSmartDelete(reg)} style={{ color: '#ef4444', background: '#fef2f2', border: 'none', padding: '6px 12px', borderRadius: '6px', cursor: 'pointer', transition: 'background 0.2s', display: 'flex', alignItems: 'center', gap: '4px', fontWeight: 'bold' }}>
                                                <TrashIcon /> <span>Excluir</span>
                                            </button>
                                        </div>
                                    </td>
                                </tr>
                            </tbody>
                        );
                    })
                )}
            </table>
            
            {hiddenList.length > 0 && (
                <div style={{ marginTop: '16px', backgroundColor: '#ebf8ff', border: '1px solid #bee3f8', borderRadius: '8px', overflow: 'hidden' }}>
                    
                    <div 
                        onClick={() => setShowHiddenRecords(!showHiddenRecords)} 
                        style={{ padding: '12px 16px', display: 'flex', alignItems: 'center', justifyContent: 'space-between', cursor: 'pointer', transition: 'background-color 0.2s' }}
                        onMouseOver={(e) => e.currentTarget.style.backgroundColor = '#e1f4ff'}
                        onMouseOut={(e) => e.currentTarget.style.backgroundColor = 'transparent'}
                    >
                        <div style={{ display: 'flex', alignItems: 'flex-start', gap: '10px' }}>
                            <div style={{ color: '#3182ce', marginTop: '2px' }}><InfoIcon /></div>
                            <div style={{ color: '#2b6cb0', fontSize: '12px', fontWeight: '600', lineHeight: '1.4' }}>
                                {hiddenList.length === 1 
                                    ? `Existe 1 lançamento ocultado da tela devido ao horário de instrução. Ele retornará ao painel às ${hiddenReturnTime}.`
                                    : `Existem ${hiddenList.length} lançamentos ocultados da tela devido ao horário de instrução. Eles retornarão ao painel às ${hiddenReturnTime}.`
                                }
                            </div>
                        </div>
                        <div style={{ color: '#3182ce', transition: 'transform 0.3s', transform: showHiddenRecords ? 'rotate(180deg)' : 'rotate(0deg)' }}>
                            <ArrowDown />
                        </div>
                    </div>
                    
                    {showHiddenRecords && (
                        <div style={{ borderTop: '1px solid #bee3f8', backgroundColor: '#f8fafc', padding: window.innerWidth < 768 ? '8px 0' : '16px' }}>
                            <table className="responsive-table" style={{ margin: 0, width: '100%' }}>
                                <thead className="desktop-only">
                                    <tr style={{ background: '#f1f5f9', color: '#94a3b8', fontSize: '11px', textAlign: 'left', textTransform: 'uppercase' }}>
                                        <th style={{ padding: '10px 12px', borderBottom: '1px dashed #cbd5e1', width: '20%' }}>Cadete</th>
                                        <th style={{ padding: '10px 12px', borderBottom: '1px dashed #cbd5e1', width: '15%' }}>Destino</th>
                                        <th style={{ padding: '10px 12px', borderBottom: '1px dashed #cbd5e1', width: '40%' }}>Detalhes</th>
                                        <th style={{ padding: '10px 12px', borderBottom: '1px dashed #cbd5e1', width: '15%' }}>Período</th>
                                        <th style={{ padding: '10px 12px', borderBottom: '1px dashed #cbd5e1', width: '10%', textAlign:'center' }}>Ações</th>
                                    </tr>
                                </thead>
                                {hiddenList.map(reg => {
                                    const isComplexo = listaDestinosComplexos.includes(reg.destino);
                                    const isRestricao = reg.destino === 'RESTRIÇÃO';
                                    const isForaAtivo = checkIsAtivoForaDaAula(reg, dataReferencia, listaDestinosComplexos);
                                    const labelFora = (isComplexo && !isRestricao) ? '[FORA DE AULA]' : `[FORA DE AULA]: ${reg.motivoForaDaAula}`;
                                    
                                    let nomeLancador = reg.nome_guerra_executor;
                                    if (!nomeLancador || nomeLancador === 'Não identificado') {
                                        const executorUser = cadetesPelotao.find(c => c.id === (reg.editadoPor || reg.criadoPor));
                                        if (executorUser) {
                                            nomeLancador = executorUser.nome_guerra ? `Cad PM ${executorUser.nome_guerra}` : `Cad PM ${executorUser.nome}`;
                                        } else {
                                            nomeLancador = 'Não identificado';
                                        }
                                    }

                                    return (
                                        <tbody key={reg.id} className={`responsive-card hidden-record-row ${expandedId === reg.id ? 'expanded' : ''}`}>
                                            <tr className="mobile-header-row desktop-hidden" onClick={() => setExpandedId(expandedId === reg.id ? null : reg.id)}>
                                                <td colSpan="5">
                                                    <div className="cadete-header">
                                                        <div className="cadete-header-info">
                                                            <span className="cadete-name-mobile" title={`Cad ${reg.cadeteNome}`}>{`Cad ${reg.cadeteNome}`}</span>
                                                            <span className="cadete-tag-mobile" style={{ backgroundColor: '#e2e8f0', color: '#475569' }}>{reg.destino}</span>
                                                        </div>
                                                        <div className="arrow-icon"><ArrowDown /></div>
                                                    </div>
                                                </td>
                                            </tr>
                                            <tr className="data-row">
                                                <td data-label="Cadete" className="desktop-only-cell" style={{ fontWeight: '600' }}>
                                                    {`Cad ${reg.cadeteNome}`}
                                                </td>
                                                <td data-label="Destino" className="desktop-only-cell">
                                                    <span style={{ padding: '4px 8px', borderRadius: '12px', fontSize: '10px', backgroundColor: '#e2e8f0', color: '#475569', fontWeight: '800' }}>
                                                        {reg.destino}
                                                    </span>
                                                </td>
                                                <td data-label="Detalhes">
                                                    <div>
                                                        {isComplexo ? (
                                                            <>
                                                                {reg.qru_motivo && <div style={{marginBottom: '2px'}}><strong>Motivo:</strong> {reg.qru_motivo}</div>}
                                                                {reg.situacao && <div style={{marginBottom: '2px'}}><strong>Situação:</strong> {reg.situacao}</div>}
                                                                {reg.qth_endereco && <div><strong>Endereço:</strong> {reg.qth_endereco}</div>}
                                                            </>
                                                        ) : (
                                                            <div>{reg.informacoes_complementares || '-'}</div>
                                                        )}
                                                        
                                                        {!reg.isTemporarioAtivo && reg.destinoTemporario && reg.detalheTemporario && (
                                                            <div style={{ color: '#805ad5', fontWeight: '700', fontSize: '10px', marginTop: '4px' }}>
                                                                [🕒 AGENDADO: {reg.destinoTemporario} ({reg.detalheTemporario}) 16h28 - 17h40]
                                                            </div>
                                                        )}

                                                        {isForaAtivo && <div style={{ fontWeight: '700', fontSize: '10px', marginTop: '4px' }}>{labelFora}</div>}
                                                        {reg.expiraAs && <div style={{ fontWeight: '700', fontSize: '10px', marginTop: '4px' }}>[EXPIRA ÀS: {reg.expiraAs}]</div>}
                                                        
                                                        <div style={{ fontSize: '9px', marginTop: '4px' }}>
                                                            Lançado por: {nomeLancador} em: {formatLaunchDate(reg.timestamp)}
                                                        </div>
                                                    </div>
                                                </td>
                                                <td data-label="Período">
                                                    {formatDatePTBR(reg.periodo_inicio)} - {formatDatePTBR(reg.periodo_fim)}
                                                </td>
                                                <td data-label="Ações" style={{ textAlign: 'center' }}>
                                                    <div className="mobile-actions-wrapper">
                                                        <button onClick={() => handleEdit(reg)} style={{ color: '#3b82f6', background: '#eff6ff', border: 'none', padding: '6px 12px', borderRadius: '6px', cursor: 'pointer', transition: 'background 0.2s', display: 'flex', alignItems: 'center', gap: '4px', fontWeight: 'bold' }}>
                                                            <EditIcon /> <span>Editar</span>
                                                        </button>
                                                        <button onClick={() => handleSmartDelete(reg)} style={{ color: '#ef4444', background: '#fef2f2', border: 'none', padding: '6px 12px', borderRadius: '6px', cursor: 'pointer', transition: 'background 0.2s', display: 'flex', alignItems: 'center', gap: '4px', fontWeight: 'bold' }}>
                                                            <TrashIcon /> <span>Excluir</span>
                                                        </button>
                                                    </div>
                                                </td>
                                            </tr>
                                        </tbody>
                                    );
                                })}
                            </table>
                        </div>
                    )}
                </div>
            )}
            
          </div>
      </div>

      {/* --- VIEW 2: TELA DE CONFERÊNCIA (APENAS MOBILE) --- */}
      <div className={`view-conference ${activeTab !== 'conference' ? 'hidden-mobile' : ''}`}>
          {cadetesProntos.length === 0 ? (
              <div style={{ padding: '30px 16px', textAlign: 'center', color: '#94a3b8', fontSize: '13px' }}>
                  Nenhum cadete em forma para conferência no momento.
              </div>
          ) : (
              <>
                  <div style={{ display: 'flex', justifyContent: 'center', marginBottom: '12px' }}>
                      <span style={{ backgroundColor: '#d1fae5', color: '#10b981', padding: '6px 20px', borderRadius: '16px', fontSize: '12px', fontWeight: '800', textTransform: 'uppercase', letterSpacing: '1px', boxShadow: '0 2px 4px rgba(0,0,0,0.05)' }}>
                          Pronto ({cadetesProntos.length})
                      </span>
                  </div>
                  <div className="conference-list">
                      {cadetesProntos.map((cadete, idx) => (
                          <div className="conference-item" key={cadete.id}>
                              <div className="conference-avatar">{idx + 1}</div>
                              <div className="conference-name" title={cadete.nome_guerra || cadete.nome}>{cadete.nome_guerra || cadete.nome}</div>
                          </div>
                      ))}
                  </div>
              </>
          )}
      </div>

      {/* --- MODAL DE NOVO LANÇAMENTO / EDIÇÃO --- */}
      {isModalOpen && (
        <div className="modal-overlay">
            <div className="modal-content">
                <h2 className="modal-title">{editingId ? 'Editar Lançamento' : 'Novo Lançamento'}</h2>
                
                <form onSubmit={formStep === 1 ? handleInitialSubmit : (e) => { e.preventDefault(); executeSave(); }}>
                    
                    {/* --- ETAPA 1: INFORMAÇÕES PRINCIPAIS --- */}
                    {formStep === 1 && (
                        <>
                            <div className="form-group">
                                <div style={{display:'flex', justifyContent:'space-between', alignItems:'center', marginBottom:'4px'}}>
                                    <label className="modern-label" style={{marginBottom:0}}>
                                        {editingId ? 'Cadete' : (isMultiSelect ? 'Selecione os Cadetes' : 'Cadete')}
                                    </label>
                                    
                                    <div style={{display:'flex', gap:'10px'}}>
                                        {!editingId && (
                                            <button type="button" onClick={() => setShowPendingOnly(!showPendingOnly)} className="toggle-mode-btn" style={{color: showPendingOnly ? '#e53e3e' : '#3b82f6'}}>
                                                {showPendingOnly ? 'Mostrar Todos' : 'Ocultar Lançados'}
                                            </button>
                                        )}
                                        {!editingId && (
                                            <button type="button" onClick={() => setIsMultiSelect(!isMultiSelect)} className="toggle-mode-btn">
                                                {isMultiSelect ? 'Selecionar Individual' : 'Selecionar Vários'}
                                            </button>
                                        )}
                                    </div>
                                </div>
                                
                                {(!isMultiSelect || editingId) ? (
                                     <select className="modern-input" value={form.cadeteId} onChange={e => handleFormChange('cadeteId', e.target.value)} required disabled={!!editingId}>
                                        <option value="">Selecione...</option>
                                        {cadetesDisponiveis.map(c => <option key={c.id} value={c.id}>{c.nome_guerra || c.nome}</option>)}
                                     </select>
                                ) : (
                                    <div className="multi-select-container">
                                        {cadetesDisponiveis.length === 0 ? (
                                            <div style={{padding:'12px', fontSize:'11px', color:'#94a3b8', textAlign:'center'}}>Nenhum cadete disponível.</div>
                                        ) : (
                                            cadetesDisponiveis.map(c => {
                                                const isSelected = form.cadetesIds?.includes(c.id);
                                                return (
                                                    <div key={c.id} className={`checkbox-item ${isSelected ? 'selected' : ''}`} onClick={() => toggleCadeteSelection(c.id)}>
                                                        <div className="custom-checkbox">{isSelected && <span className="checkbox-tick">✓</span>}</div>
                                                        <span className="cadete-name-select">{c.nome_guerra || c.nome}</span>
                                                    </div>
                                                );
                                            })
                                        )}
                                    </div>
                                )}
                                {!editingId && isMultiSelect && <div style={{fontSize: '10px', color: '#64748b', marginTop: '4px', textAlign:'right'}}>{form.cadetesIds?.length || 0} selecionado(s)</div>}
                            </div>

                            <div className="form-group">
                                <label className="modern-label">Destino Principal</label>
                                <select 
                                    className="modern-input" 
                                    value={form.destino} 
                                    onChange={e => handleFormChange('destino', e.target.value)} 
                                    required
                                    disabled={!!editingId} 
                                    style={editingId ? {backgroundColor: '#e2e8f0', cursor: 'not-allowed'} : {}}
                                >
                                    <option value="">Selecione...</option>
                                    <optgroup label="Simples">{listaDestinosSimples.map(d => <option key={d} value={d}>{d}</option>)}</optgroup>
                                    <optgroup label="Detalhados">{listaDestinosComplexos.map(d => <option key={d} value={d}>{d}</option>)}</optgroup>
                                </select>
                            </div>

                            {/* BLOCO ATIVIDADE TEMPORÁRIA */}
                            <div className="form-group">
                                <div className="form-section-light" style={{ borderColor: showTemporario ? '#e9d8fd' : '#e2e8f0', backgroundColor: showTemporario ? '#faf5ff' : '#f8fafc', transition: 'all 0.3s ease', padding: '12px' }}>
                                    <div 
                                        onClick={toggleTemporarioAccordion}
                                        style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', cursor: 'pointer' }}
                                    >
                                        <div>
                                            <label className="modern-label" style={{ color: showTemporario ? '#6b46c1' : '#64748b', marginBottom: 0, cursor: 'pointer' }}>
                                                Atividade Temporária (Grêmio/Equipe)
                                            </label>
                                            {!showTemporario && <div style={{ fontSize: '10px', color: '#94a3b8', marginTop: '2px' }}>Clique para adicionar um grêmio ou equipe temporária.</div>}
                                        </div>
                                        <div style={{ color: showTemporario ? '#6b46c1' : '#94a3b8', transition: 'transform 0.3s', transform: showTemporario ? 'rotate(180deg)' : 'rotate(0deg)' }}>
                                            <ArrowDown />
                                        </div>
                                    </div>
                                    
                                    {showTemporario && (
                                        <div style={{ marginTop: '12px', paddingTop: '12px', borderTop: '1px dashed #e9d8fd', animation: 'fadeInDown 0.2s ease-out' }}>
                                            <div style={{ fontSize: '10px', color: '#805ad5', marginBottom: '10px', lineHeight: '1.4' }}>
                                                Substitui o destino principal automaticamente às <strong>16:28</strong> e retorna ao normal às <strong>17:40</strong>.
                                            </div>
                                            
                                            <div className="form-row">
                                                <div>
                                                    <label className="modern-label" style={{ fontSize: '9px', color: '#6b46c1' }}>Tipo</label>
                                                    <select 
                                                        className="modern-input"
                                                        value={form.destinoTemporario || ''}
                                                        onChange={e => {
                                                            handleFormChange('destinoTemporario', e.target.value);
                                                            handleFormChange('detalheTemporario', '');
                                                        }}
                                                        style={{ borderColor: '#d6bcfa', backgroundColor: '#fff' }}
                                                    >
                                                        <option value="">Nenhum</option>
                                                        <option value="GRÊMIOS">GRÊMIOS</option>
                                                        <option value="EQUIPES">EQUIPES</option>
                                                    </select>
                                                </div>
                                                {form.destinoTemporario && (
                                                    <div>
                                                        <label className="modern-label" style={{ fontSize: '9px', color: '#6b46c1' }}>Nome</label>
                                                        <select 
                                                            className="modern-input"
                                                            value={form.detalheTemporario || ''}
                                                            onChange={e => handleFormChange('detalheTemporario', e.target.value)}
                                                            style={{ borderColor: '#d6bcfa', backgroundColor: '#fff' }}
                                                            required={!!form.destinoTemporario}
                                                        >
                                                            <option value="">Selecione...</option>
                                                            {form.destinoTemporario === 'GRÊMIOS' 
                                                                ? listaGremios.map(g => <option key={g} value={g}>{g}</option>)
                                                                : listaEquipes.map(e => <option key={e} value={e}>{e}</option>)
                                                            }
                                                        </select>
                                                    </div>
                                                )}
                                            </div>
                                            
                                            {form.destinoTemporario && form.detalheTemporario && (
                                                <div style={{ marginTop: '10px', padding: '8px', backgroundColor: '#ebf8ff', border: '1px solid #bee3f8', borderRadius: '6px', fontSize: '11px', color: '#2b6cb0', fontWeight: '600', display: 'flex', alignItems: 'flex-start', gap: '6px' }}>
                                                    <div style={{ marginTop: '1px' }}><InfoIcon /></div>
                                                    <span>
                                                        Às 16h28 este cadete constará em <strong>{form.destinoTemporario} ({form.detalheTemporario})</strong>. Às 17h40, retornará para o destino acima (ou expirará se for o caso).
                                                    </span>
                                                </div>
                                            )}
                                        </div>
                                    )}
                                </div>
                            </div>

                            {listaDestinosSimples.includes(form.destino) && (
                                <div className="form-group">
                                    {form.destino === 'GRÊMIOS' ? (
                                        <>
                                            <label className="modern-label">Selecione o Grêmio</label>
                                            <select className="modern-input" value={form.informacoes_complementares} onChange={e => handleFormChange('informacoes_complementares', e.target.value)} required>
                                                <option value="">Selecione o grêmio...</option>
                                                {listaGremios.map(g => <option key={g} value={g}>{g}</option>)}
                                            </select>
                                        </>
                                    ) : form.destino === 'EQUIPES' ? (
                                        <>
                                            <label className="modern-label">Selecione a Equipe</label>
                                            <select className="modern-input" value={form.informacoes_complementares} onChange={e => handleFormChange('informacoes_complementares', e.target.value)} required>
                                                <option value="">Selecione a equipe...</option>
                                                {listaEquipes.map(eq => <option key={eq} value={eq}>{eq}</option>)}
                                            </select>
                                        </>
                                    ) : (
                                        <>
                                            <label className="modern-label">Informações Complementares</label>
                                            <input 
                                                className="modern-input" 
                                                value={form.informacoes_complementares} 
                                                onChange={e => handleFormChange('informacoes_complementares', e.target.value)} 
                                                required 
                                                placeholder="Ex: Al de Dia"
                                            />
                                        </>
                                    )}
                                </div>
                            )}
                            
                            {(listaDestinosComplexos.includes(form.destino) || destinosComDataExtra.includes(form.destino)) && (
                                <div className="form-section">
                                    {listaDestinosComplexos.includes(form.destino) && (
                                        <>
                                            <div className="form-group">
                                                <label className="modern-label">Motivo / QRU</label>
                                                <textarea className="modern-input" value={form.qru_motivo} onChange={e => handleFormChange('qru_motivo', e.target.value)} required placeholder="Descreva o motivo..." />
                                            </div>
                                            <div className="form-row">
                                                <div>
                                                    <label className="modern-label">Situação</label>
                                                    <select 
                                                        className="modern-input" 
                                                        value={form.situacao} 
                                                        onChange={e => handleFormChange('situacao', e.target.value)} 
                                                        required
                                                    >
                                                        <option value="">Selecione...</option>
                                                        <option value="RESIDÊNCIA">RESIDÊNCIA</option>
                                                        <option value="ALOJAMENTO">ALOJAMENTO</option>
                                                        <option value="ROTINA NORMAL">ROTINA NORMAL</option>
                                                        <option value="SERVIÇO FORA">SERVIÇO FORA</option>
                                                        <option value="OUTROS FORA">OUTROS FORA</option>
                                                    </select>
                                                </div>
                                                <div><label className="modern-label">Endereço / QTH</label><input className="modern-input" value={form.qth_endereco} onChange={e => handleFormChange('qth_endereco', e.target.value)} required placeholder="R. Alino Paiva, 68, Osasco/SP" /></div>
                                            </div>
                                        </>
                                    )}
                                    
                                    <div className="date-inputs-wrapper" style={{ display: 'flex', gap: '12px' }}>
                                        <div className="date-input-field" style={{ flex: 1 }}>
                                            <label className="modern-label">Início</label>
                                            <input 
                                                type="date" 
                                                className="modern-input" 
                                                value={form.periodo_inicio} 
                                                onChange={e => handleFormChange('periodo_inicio', e.target.value)} 
                                                required 
                                                disabled={!!editingId}
                                                style={editingId ? {backgroundColor: '#e2e8f0', cursor: 'not-allowed'} : {}}
                                            />
                                        </div>
                                        <div className="date-input-field" style={{ flex: 1 }}>
                                            <label className="modern-label">Fim</label>
                                            <input 
                                                type="date" 
                                                className="modern-input" 
                                                value={form.periodo_fim} 
                                                onChange={e => handleFormChange('periodo_fim', e.target.value)} 
                                                required 
                                                disabled={!!editingId}
                                                style={editingId ? {backgroundColor: '#e2e8f0', cursor: 'not-allowed'} : {}}
                                            />
                                        </div>
                                    </div>
                                    
                                    {!editingId && (
                                        <div style={{ display: 'flex', gap: '8px', marginTop: '10px', flexWrap: 'wrap' }}>
                                            {[0,1,2,7].map(d => (
                                                <button key={d} type="button" className="modern-chip-btn" onClick={() => setQuickDuration(d)}>
                                                    {d === 0 ? 'Hoje' : `+${d}d`}
                                                </button>
                                            ))}
                                        </div>
                                    )}
                                </div>
                            )}

                            <div className="modal-actions">
                                <button type="button" onClick={() => setIsModalOpen(false)} className="modern-btn-secondary">Cancelar</button>
                                <button type="submit" className="modern-btn-primary" disabled={loading}>
                                    {(listaDestinosSimples.includes(form.destino) || form.destino === 'RESTRIÇÃO') ? 'Continuar' : 'Salvar'}
                                </button>
                            </div>
                        </>
                    )}


                    {/* --- ETAPA 2: CONFIRMAÇÃO DE HORÁRIO (FORA DE AULA) --- */}
                    {formStep === 2 && (
                        <>
                            <div style={{ padding: '12px', backgroundColor: '#f1f5f9', borderRadius: '8px', marginBottom: '16px' }}>
                                <div style={{ fontSize: '11px', color: '#64748b', fontWeight: '700', textTransform: 'uppercase' }}>Resumo do Lançamento</div>
                                <div style={{ fontSize: '14px', color: '#1e293b', fontWeight: '800', marginTop: '4px' }}>
                                    {form.destino} {form.informacoes_complementares && `- ${form.informacoes_complementares}`}
                                </div>
                            </div>

                            <div style={{ marginBottom: '12px', fontSize: '14px', color: '#334155', fontWeight: '700' }}>
                                Confirmação de Horário de Instrução:
                            </div>

                            <div className="form-group">
                                <div className="form-section-light">
                                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: form.expiraAs ? '0' : '12px' }}>
                                        <span style={{ fontSize: '12px', fontWeight: '700', color: '#334155' }}>Expira às:</span>
                                        <input 
                                            type="time" 
                                            value={form.expiraAs || ''} 
                                            onChange={e => {
                                                const val = e.target.value;
                                                handleFormChange('expiraAs', val);
                                                if (val) {
                                                    handleFormChange('isForaDaAula', false);
                                                    handleFormChange('motivoForaDaAula', '');
                                                }
                                            }} 
                                            className="modern-input" 
                                            style={{ width: 'auto', padding: '4px 8px', height: '30px' }} 
                                        />
                                    </div>

                                    {form.expiraAs && (
                                        <div style={{ marginTop: '8px', padding: '8px', backgroundColor: '#ebf8ff', borderRadius: '6px', fontSize: '11px', color: '#3182ce', fontWeight: '600', display: 'flex', alignItems: 'flex-start', gap: '6px' }}>
                                            <div style={{ marginTop: '1px' }}><InfoIcon /></div>
                                            <span>Este registro <strong>expirará e sumirá do sistema exatamente às {form.expiraAs}</strong>.</span>
                                        </div>
                                    )}

                                    {!form.expiraAs && (
                                        <>
                                            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                                <span style={{ fontSize: '12px', fontWeight: '700', color: '#334155' }}>O Cadete estará Fora da Aula?</span>
                                                <button type="button" onClick={handleToggleForaDaAula} style={{ padding: '4px 12px', backgroundColor: form.isForaDaAula ? '#ef4444' : '#e2e8f0', color: form.isForaDaAula ? '#fff' : '#475569', border: 'none', borderRadius: '20px', cursor: 'pointer', fontSize: '10px', fontWeight: '700', transition: 'all 0.2s' }}>
                                                    {form.isForaDaAula ? 'SIM' : 'NÃO'}
                                                </button>
                                            </div>
                                            {form.isForaDaAula && (
                                                <select value={form.motivoForaDaAula} onChange={e => handleFormChange('motivoForaDaAula', e.target.value)} className="modern-input" style={{ marginTop: '8px' }} required>
                                                    <option value="">Selecione o Tempo...</option>
                                                    {OPCOES_FORA_DA_AULA.map(o => <option key={o} value={o}>{o}</option>)}
                                                </select>
                                            )}
                                            
                                            {form.isForaDaAula && form.motivoForaDaAula && (
                                                <div style={{ marginTop: '10px', padding: '8px', backgroundColor: '#ebf8ff', borderRadius: '6px', fontSize: '11px', color: '#3182ce', fontWeight: '600', display: 'flex', alignItems: 'flex-start', gap: '6px' }}>
                                                    <div style={{ marginTop: '1px' }}><InfoIcon /></div>
                                                    <span>Este lançamento ativará o estado de "Fora de Aula" e <strong>expirará e sumirá do sistema automaticamente às {getExpirationString(form.motivoForaDaAula)}</strong>.</span>
                                                </div>
                                            )}
                                            {!form.isForaDaAula && form.destino && form.destino !== 'RESTRIÇÃO' && (
                                                <div style={{ marginTop: '10px', padding: '8px', backgroundColor: '#ebf8ff', borderRadius: '6px', fontSize: '11px', color: '#3182ce', fontWeight: '600', display: 'flex', alignItems: 'flex-start', gap: '6px' }}>
                                                    <div style={{ marginTop: '1px' }}><InfoIcon /></div>
                                                    <span>Como a opção "Fora da Aula" está marcada como NÃO, <strong>este registro não aparecerá na tela durante os horários de instrução</strong> (08h15 às 11h30 e 13h00 às 16h30).</span>
                                                </div>
                                            )}
                                        </>
                                    )}
                                </div>
                            </div>

                            <div className="modal-actions">
                                <button type="button" onClick={() => setFormStep(1)} className="modern-btn-secondary">Voltar</button>
                                <button type="submit" className="modern-btn-primary" disabled={loading}>
                                    {loading ? 'Salvando...' : 'Confirmar e Salvar'}
                                </button>
                            </div>
                        </>
                    )}

                </form>
            </div>
        </div>
      )}
    </div>
  );
};

export default ResultadoOnlinePage;